import * as types from './actionTypes';

export const changeVpnModal = (status) => ({ type: types.CHANGE_VPN_MODAL, payload: status });
export const changeAppModal = (status) => ({ type: types.CHANGE_APP_MODAL, payload: status });
